import { getSessionStorage } from "../utils/storageSecurity"

export const userSession={
    userData: JSON.parse(getSessionStorage("userData"))
}
// export const statusSession={
// statusData : JSON.parse(getSessionStorage("statusData"))
// }
// console.log('userDataConst',userSession.userData,statusSession.statusData)